import React from 'react'
import FormHeaderSaveActions from './action_button/FormHeaderSaveActions'

/**
 * Barra sticky reutilizable: título a la izquierda y hasta 3 botones a la derecha
 * (Atrás, Cancelar, primario) vía FormHeaderSaveActions.
 *
 * Uso:
 *   <StickyActionBar
 *     title="Define el nombre del rol..."
 *     hint={saving ? 'Guardando, no cierres la ventana...' : ''}
 *     onCancel={handleCancel}
 *     onPrimaryClick={handleNext}
 *     primaryLabel="Siguiente"
 *     primaryIcon={CaretRight}
 *     primaryButtonType="button"
 *     primaryDisabled={disabled}
 *     isSaving={saving}
 *   />
 *
 * En un paso posterior, pasa onBack para mostrar el tercer botón (Atrás).
 *
 * Props propias:
 *   title — texto a la izquierda
 *   hint  — opcional, mensaje junto a los botones (p.ej. estado de guardado)
 *
 * El resto de props se reenvían a FormHeaderSaveActions:
 *   onBack, onCancel, onPrimaryClick, backLabel, cancelLabel, primaryLabel,
 *   primaryIcon, primaryDisabled, isSaving, hideSecondaryActions, savingLabel,
 *   primaryButtonType, showPrimaryIcon, etc.
 *
 * Si se pasan children, reemplazan los botones por defecto.
 */
export default function StickyActionBar({ title, hint = '', className = '', children, ...buttonProps }) {
  const rootClass = ['index-table', 'sticky-action-bar', className].filter(Boolean).join(' ')

  return (
    <div className={rootClass}>
      <div className="show-area show-area--flush sticky-action-bar__inner">
        <p className="sticky-action-bar__title">{title}</p>
        <div className="sticky-action-bar__actions-wrap">
          {hint ? (
            <p className="sticky-action-bar__hint" aria-live="polite">
              {hint}
            </p>
          ) : null}
          {children ?? (
            <FormHeaderSaveActions
              {...buttonProps}
              className="sticky-action-bar__actions"
              stackOnMobile
            />
          )}
        </div>
      </div>
    </div>
  )
}
